import PropTypes from "prop-types";

import { Paragraph2, SVG } from "../../components";
import { AddButtonStyled } from "./styled";

const AddButton = ({ onClick, children, disabled, ...rest }) => {
  return (
    <AddButtonStyled onClick={() => onClick()} disabled={disabled} {...rest}>
      <SVG.AddIcon />
      <Paragraph2>{children}</Paragraph2>
    </AddButtonStyled>
  );
};

AddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default AddButton;
